import React, { Fragment, useState } from 'react'
import { flatMap } from 'lodash'
import PropTypes from 'prop-types'
import Table from 'UI/Table'

import { assetColumns, customerColumns } from './Columns'
import { Filters, defaultFilters } from './Filters'
import filteresAssetsData from './Data'

const OnPremiseCoverage = ({ assets = [] }) => {
  const [filters, changeFilters] = useState(defaultFilters)
  const data = filteresAssetsData({ assets, filters })

  const tableData = {
    data,
    columns: customerColumns(),
    className: 'table',
    defaultSorted: [{ id: 'customer_name', asc: true }],
    SubComponent: (row) => (
      <Table
        filterable
        data={row.original.assets}
        columns={assetColumns()}
      />
    )
  }

  return (
    <Fragment>
      <Filters {...{ filters, changeFilters, assets: flatMap(assets, 'assets') }} />

      <Table {...tableData} />
    </Fragment>
  )
}

export default OnPremiseCoverage
